export * from './feitertage-interface';
